"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Beauty = function Beauty(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "12.25",
    y: "14.3906",
    width: "5.90625",
    height: "10.3281",
    fill: "#F3B8B8"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "13.0312",
    y: "11.1719",
    width: "4.25",
    height: "3.21875",
    fill: "#F3B8B8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.5156 7.53125L14.1875 6.42188L16.8281 5.25V11.1719H13.5156V7.53125Z",
    fill: "#F3B8B8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.725 14.1671H17.5201V11.5476C17.5201 11.2589 17.3152 11.0153 17.0408 10.9485V5.48771C17.0408 5.30996 16.95 5.15476 16.7896 5.06633C16.6302 4.97789 16.4708 4.97789 16.3104 5.06633L14.3721 6.13194C13.7334 6.48744 13.3228 7.175 13.3228 7.93022V10.9494C13.0493 11.0162 12.8436 11.2598 12.8436 11.5485V14.1895H12.6387C12.2966 14.1895 12 14.4557 12 14.8112V23.8234C12 24.4668 12.5469 25 13.2088 25H17.154C17.8149 25 18.3627 24.4676 18.3627 23.8234L18.3636 14.7887C18.3405 14.4558 18.067 14.1671 17.725 14.1671ZM13.7797 7.92938C13.7797 7.35191 14.0986 6.81955 14.601 6.53082L16.5393 5.4652C16.5393 5.4652 16.5625 5.48861 16.5625 5.51029V10.9484H13.7798L13.7797 7.92938ZM13.3014 11.5476C13.3014 11.4592 13.37 11.3924 13.4608 11.3924H16.8813C16.9722 11.3924 17.0408 11.4592 17.0408 11.5476V14.1886H13.3015L13.3014 11.5476ZM17.8844 23.7999C17.8844 24.1996 17.5655 24.51 17.1549 24.51H13.1876C12.7769 24.51 12.458 24.1996 12.458 23.7999V16.0979H17.8855L17.8844 23.7999ZM12.4579 15.6314V14.7877C12.4579 14.6993 12.5265 14.6325 12.6173 14.6325H17.7027C17.7936 14.6325 17.8622 14.6993 17.8622 14.7877V15.6314H12.4579Z",
    fill: "#BD0000"
  }));
};

Beauty.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
Beauty.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = Beauty;
exports.default = _default;